import {
  useAPIQueryAndQueryKey,
  DesignCollectionsDraftApi,
} from "melco-shared-logic";
import { PublishState } from "../../../helper/publishedState";

export const queryKeyForDesignCollection = (
  designCollectionId: string,
  publishState: PublishState
) => ["designCollection", designCollectionId, publishState];

export const useDesignCollection = (
  designCollectionId: string,
  publishState: PublishState
) => {
  return useAPIQueryAndQueryKey(
    DesignCollectionsDraftApi,
    queryKeyForDesignCollection(designCollectionId, publishState),
    async (api) =>
      api.userDesignCollectionsGetDef({ id: designCollectionId, publishState })
  );
};
